import { navLinks } from "../../../mocks/homeData";

export default function Footer() {
  return (
    <footer className="bg-secondary-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6 py-12">
        <div className="grid grid-cols-1 gap-8 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr]">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-md bg-primary-500 text-background-50">
                <i className="ri-message-3-fill text-base"></i>
              </span>
              <p className="font-heading text-xl font-black text-foreground-950">92爆料</p>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-foreground-600">
              一个把一手材料、私信线索与吃瓜讨论摆上同一张桌子的线索投稿社区。有瓜可发、有料可报，投稿私信与关注对接入口明确。
            </p>
          </div>

          <div>
            <p className="text-sm font-bold text-foreground-950">站内直达</p>
            <ul className="mt-4 space-y-2.5">
              {navLinks.map((l) => (
                <li key={l.href}>
                  <a href={l.href} className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                    {l.label}
                  </a>
                </li>
              ))}
              <li>
                <a href="#entrance" className="text-sm text-foreground-600 hover:text-primary-600 transition-colors">
                  投稿私信入口
                </a>
              </li>
            </ul>
          </div>

          <div>
            <p className="text-sm font-bold text-foreground-950">关于投稿</p>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>匿名称呼可自选</li>
              <li>私信材料默认打码再公开</li>
              <li>待核实线索会标记复盘状态</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 border-t border-secondary-200 pt-6">
          <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
            <p className="text-xs text-foreground-500">
              © {new Date().getFullYear()} 92爆料 · 线索投稿讨论社区
            </p>
            <p className="max-w-xl text-xs leading-relaxed text-foreground-500">
              本站首页为线索社区演示壳层，投稿、关注、下载与评论入口均为示意展示，不接真实登录与提交，也不构成对任何个人或组织的指摘。理性吃瓜，拒绝造谣传谣。
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}